require('./student-visa-usa.scss');
import {submitMailCta} from "../utils";

$(() => {
        submitMailCta();
    }
);